export const ACTION_ITEMS = {
    UPLOAD_BUTTON: 'Upload',
    CANCEL_BUTTON: 'Cancel',
    SEARCH_BUTTON: 'Search',
    UPDATE_BUTTON: 'Update',
    CONFIRM_BUTTON: 'Confirm',
    PROCEED_BUTTON: 'Proceed',
    SAVE_BUTTON: 'Save',
    BACK_BUTTON: 'Back',
    NEXT_BUTTON: 'Next',
    ADD_NEW_BUTTON: 'Add New',
    SUBMIT_BUTTON: 'Submit',
    QUIT_MAPPING: 'Quit mapping',
    EDIT_BUTTON:'Edit'
};
